import { FC, useCallback, useEffect, useState } from 'react';
import Datepicker from 'react-tailwindcss-datepicker';
import './style.css';

interface ICustomRangeDatePickerWithModesProps {
  onChange: (values: IDatePickerWithModes) => void;
  value?: IDatePickerWithModes;
  maxDate?: Date | undefined;
  minDate?: Date | undefined;
  shortcuts?: any;
  width?: number;
  placeholder?: string;
}

interface IDatePickerWithModes {
  startDate: string;
  endDate: string;
  mode?: RANGE_DATE_PICKER_MODE;
}

export enum RANGE_DATE_PICKER_MODE {
  PERIOD = 'period',
  SEPARATE = 'separate',
}

const CustomRangeDatePickerWithModes: FC<ICustomRangeDatePickerWithModesProps> = ({
  onChange,
  value,
  shortcuts,
  maxDate,
  minDate,
  width = 130,
  placeholder,
}) => {
  const [mode, setMode] = useState(RANGE_DATE_PICKER_MODE.PERIOD);

  useEffect(() => {
    const dayNamesContainer = document?.getElementsByClassName(
      'grid grid-cols-7 border-b border-gray-300 dark:border-gray-700 py-2'
    )[0];
    for (let item of dayNamesContainer.children) {
      switch (item.innerHTML) {
        case 'Пнд':
          item.innerHTML = 'Пн';
          break;
        case 'Втр':
          item.innerHTML = 'Вт';
          break;
        case 'Срд':
          item.innerHTML = 'Ср';
          break;
        case 'Чтв':
          item.innerHTML = 'Чт';
          break;
        case 'Птн':
          item.innerHTML = 'Пт';
          break;
        case 'Сбт':
          item.innerHTML = 'Сб';
          break;
        case 'Вск':
          item.innerHTML = 'Вс';
          break;
      }
    }
  }, []);

  /*
    useEffect(() => {
        const datepickerPopup = document?.getElementsByClassName("datepicker-popup")[0]

        const wrapperDiv = document.createElement("div")
        wrapperDiv.style.setProperty('position','absolute','')
        wrapperDiv.style.setProperty('bottom','15px','')
        wrapperDiv.style.setProperty('left','100px','')
        wrapperDiv.classList.add("flex", "items-center", "gap-[20px]", 'w-[110px]', 'justify-between')

        const PeriodDiv = createModeOption('Период', RANGE_DATE_PICKER_MODE.PERIOD)
        const SeparateDatesDiv = createModeOption('Отдельно', RANGE_DATE_PICKER_MODE.SEPARATE)

        wrapperDiv.appendChild(PeriodDiv)
        wrapperDiv.appendChild(SeparateDatesDiv)
        datepickerPopup.appendChild(wrapperDiv)
    }, [mode]);

    const createModeOption = useCallback((label: string, value: RANGE_DATE_PICKER_MODE) => {
        const $wrapper = document.createElement('div')
        $wrapper.onclick = () => setMode(value)
        $wrapper.classList.add("flex", "items-center", "gap-[20px]", "cursor-pointer")

        const $indicator = document.createElement('div')
        $wrapper.classList.add('rounded-[50%]', 'w-[14px]', 'h-[14px]', 'border', 'border-solid', 'border-[white]', `${mode === value ? 'bg-[white]' : null}`)

        const $label = document.createElement('div')
        $label.textContent = label

        $wrapper.appendChild($indicator)
        $wrapper.appendChild($label)

        return $wrapper
    }, [mode])
     */

  return (
    <div
      style={{ minWidth: `${width}px`, maxWidth: `${width}px` }}
      className={`rounded-[8px] bg-[#211F24] text-[black] cursor-pointer relative h-[33px]`}
    >
      <Datepicker
        value={{
          startDate: value?.startDate ? new Date(value.startDate) : null,
          endDate: value?.endDate ? new Date(value.endDate) : null,
        }}
        onChange={(newValue: any) => onChange({ ...newValue, mode })}
        useRange={false}
        i18n={'ru'}
        placeholder={placeholder ?? 'Дата'}
        maxDate={maxDate}
        minDate={minDate}
        displayFormat="DD.MM.YY"
        showShortcuts={shortcuts !== undefined}
        startWeekOn={'mon'}
        showFooter={false}
        primaryColor="cyan"
        readOnly={true}
        separator="-"
        configs={{
          shortcuts,
          footer: {
            cancel: 'Закрыть',
            apply: 'Применить',
          },
        }}
        inputClassName={
          'cursor-pointer relative text-[12px] py-2 pl-4 pr-14 w-full border-gray-300 dark:bg-[#201F24] dark:text-white outline-none rounded-lg placeholder-[white]'
        }
        popupClassName={
          'datepicker-popup transition-all ease-out duration-300 absolute z-[10000] mt-[1px] text-sm lg:text-xs 2xl:text-sm translate-y-4 opacity-0 hidden mb-2.5 mt-2.5 range-date-picker-dropdown'
        }
        toggleClassName={
          'absolute right-0 h-full px-3 text-white focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed'
        }
      />
    </div>
  );
};

export default CustomRangeDatePickerWithModes;
